export const translatedPrice = (priceInMinorUnits: number, digits: number, currency: string, locale: NavigatorLanguage['language'] = 'en-US') => {
  return Math.round(priceInMinorUnits / Math.pow(10, digits)).toLocaleString(locale, {
    style: 'currency',
    maximumSignificantDigits: 3,
    currency
  });
};

export const getPercentageOff = (
  minimumPercentageOffToDisplay: number,
  priceInMinorUnits?: number,
  strikeOutPriceInMinorUnits?: number,
  priceDigits?: number,
  strikeOutPriceDigits?: number
): number | undefined => {
  if (!priceInMinorUnits || !strikeOutPriceInMinorUnits || !priceDigits || !strikeOutPriceDigits) return undefined;

  const price = priceInMinorUnits / Math.pow(10, priceDigits);
  const strikeOutPrice = strikeOutPriceInMinorUnits / Math.pow(10, strikeOutPriceDigits);
  const percentageOff = Math.round(((strikeOutPrice - price) / strikeOutPrice) * 100);
  return percentageOff >= minimumPercentageOffToDisplay ? percentageOff : undefined;
};
